import { useEffect } from 'react';
import { Input as AntdInput, Checkbox as AntdCheckbox, DatePicker as AntdDatePicker } from 'antd';
import styled from 'styled-components';
import { BorderedField, Flex } from './Flex';
import { ClipIcon } from '../icons/ClipIcon';
import { CancelIcon } from '../icons/CancelIcon';
import { Paragraph } from './Text';
import { ExplainIcon } from '../icons/ExplainIcon';
import { FormTooltip } from './Tooltip';

const StyledInput = styled(AntdInput).attrs({
    bordered: false
})`
    height: ${({ height}) => height ? height : "32px"};
    font-size: 14px;
    line-height: 19px;
    color: #163466;
    text-transform: ${({ uppercase }) => uppercase && 'uppercase'}
`;

const StyledTextArea = styled(AntdInput.TextArea).attrs({
    rows: 3,
    autoSize: { minRows: 3, maxRows: 3 },
    bordered: false
})`
    color: var(--sp-text-color);
`;

const StyledDatePicker = styled(AntdDatePicker).attrs({
    autoFocus: true,
    bordered: false,
    suffixIcon: null,
    allowClear: false,
    placeholder: null,
    open: true
})`
    width: 100%;
`;

export const DatePicker = (props) => (<StyledDatePicker {...props} />);

export const Input = ({ inputRef, ...props}) => (
    props.bordered
        ? <BorderedField>
            <StyledInput {...props} />
        </BorderedField>
        : <StyledInput ref={inputRef} {...props} />
);

Input.TextArea = (props) => (
    props.bordered
        ? <BorderedField {...props}>
            <StyledTextArea {...props} />
        </BorderedField>
        : <StyledTextArea {...props} />
    );

const StyledInputFileLabel = styled.label`
    padding: ${({ padding }) => padding};
    flex: 1;
    display: flex;
    align-items: center;
    width: calc(100% - 20px);
    border-radius: 8px;
    & > i {
        color: #E4EDFD;
    }

    &:hover > i, &:focus > i {
        color: #d2e1fc;
    }

    &[disabled] {
        cursor: not-allowed;
    }
`;

const StyledInputFile = styled.input.attrs({
    type: "file",
    onClick: (e) => { e.target.value = null }
})`
    display: none;
`;

export const InputFile = ({ selected, onCancel, error, ...props}) => (
    <BorderedField hasError={typeof error == "string"} padding={{ top: "4px", bottom: "4px", left: "10px", right: "10px" }}>
        <StyledInputFileLabel disabled={props.disabled}>
            <ClipIcon disabled={props.disabled} style={{ marginRight: "8px" }} />
            {selected
            ? <Paragraph title={selected.name} nowrap disabled={props.disabled}>{selected.name}</Paragraph>
            : <Paragraph blur>Browse file...</Paragraph>}
            <StyledInputFile {...props}/>
        </StyledInputFileLabel>
        {selected && <CancelIcon onClick={() => !props.disabled && onCancel()} {...props} />}
        {error &&
            <>
                <FormTooltip text={error}>
                    <ExplainIcon />
                </FormTooltip>
            </>}
    </BorderedField>
);

const StyledCheckbox = styled(AntdCheckbox)`
    color: #28436F;

    & .ant-checkbox-inner {
        border: 1px solid #E4EDFD;
    }
`;

export const Checkbox = (props) => (
        <StyledCheckbox {...props}>
            {props.children}
        </StyledCheckbox>
);

const IssueComment = ({ text, onTextChange, disabled, onFileChange, pingServer, ...props}) => {
    useEffect(() => {
        let interval;
        if (text) {
            interval = setInterval(() => {
                pingServer();
            }, 1200000)
        };

        return () => clearInterval(interval);
    }, [ text ]);

    return (
        <BorderedField align="start">
            <StyledInputFileLabel disabled={disabled} padding="6px 0px 0px 6px">
                <ClipIcon disabled={disabled}/>
                <StyledInputFile
                    name="file"
                    disabled={disabled}
                    onChange={(e) => {
                        e.persist();
                        if (e.target && e.target.files) onFileChange(e.target.files[0]);
                    }}
                />
            </StyledInputFileLabel>
            <Input.TextArea
                autoFocus
                value={text}
                onChange={(e) => {
                    e.persist();
                    onTextChange(e.target.value);
                }}
            />
        </BorderedField>
    )

};

export { IssueComment }